import { handleError, handleSuccess, triggerDelete, triggerGet, triggerPost, triggerPut } from './utils';
const getAllSessionsApiRequest = async function (id) {
  let isPublic = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const apiResponse = await triggerGet("/".concat(isPublic ? 'public' : 'business', "/classes/").concat(id, "/sessions/"), !isPublic);
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    return handleSuccess(responseData);
  }
  if (responseData.report.status === 404) {
    return handleSuccess({
      success: true,
      data: [],
      report: {}
    });
  }
  return handleError(responseData);
};

// Create Session in class
const createSessionApiRequest = async data => {
  const apiResponse = await triggerPost('/business/sessions/', data);
  const responseData = await apiResponse.json();
  if (responseData.report.status === 201) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};

// Edit/Update Session
const editSessionApiRequest = async (data, id) => {
  const apiResponse = await triggerPut("/business/sessions/".concat(id, "/"), data);
  const responseData = await apiResponse.json();
  if (responseData.report.status === 200) {
    return handleSuccess(responseData);
  }
  return handleError(responseData);
};
const deleteSessionApiRequest = async id => {
  const apiResponse = await triggerDelete("/business/sessions/".concat(id, "/"));
  if (apiResponse.status === 204) {
    return {
      success: true,
      data: [],
      report: {}
    };
  }
  return {
    success: false
  };
};
export { getAllSessionsApiRequest, createSessionApiRequest, editSessionApiRequest, deleteSessionApiRequest };